import React from 'react'
import { connect } from 'react-redux'

import Autosuggest from 'react-autosuggest';
import CustomOutlinedButton from './Mui/CustomOutlinedButton';
import Grid from '@material-ui/core/Grid';
import InnerBar from './InnerBar';
import { MuiThemeProvider } from '@material-ui/core/styles';
import TextInput from './inputs/TextInput'

import {
  LocalForm,
  Control,
  actions
} from 'react-redux-form'

const theme = {
  container:                'react-autosuggest__container customContainerWidth',
  containerOpen:            'react-autosuggest__container--open',
  input:                    'react-autosuggest__input',
  inputOpen:                'react-autosuggest__input--open',
  inputFocused:             'react-autosuggest__input--focused',
  suggestionsContainer:     'react-autosuggest__suggestions-container customSuggestionsContainer',
  suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
  suggestionsList:          'react-autosuggest__suggestions-list customSuggestionsList',
  suggestion:               'react-autosuggest__suggestion customSuggestion',
  suggestionFirst:          'react-autosuggest__suggestion--first',
  suggestionHighlighted:    'react-autosuggest__suggestion--highlighted',
  sectionContainer:         'react-autosuggest__section-container',
  sectionContainerFirst:    'react-autosuggest__section-container--first',
  sectionTitle:             'react-autosuggest__section-title'
}
// import {
//   update_voucher,
// } from '../actions'

// const mapStateToProps = state => {
//   return {
//
//   }
// }
//
// const mapDispatchToProps = dispatch => {
//   return {
//     // updateVoucher: (voucher_id, values) => dispatch( update_voucher(voucher_id, values) ),
//   };
// };

class ConnectedVoucherCampaignEdit extends React.Component {
  state = {
    campaign: '',
    campaigns: [],
    showCampaignSuggestions: false,
    filtered_campaigns: [],
    formData: null,
  }

  attachDispatch(dispatch) {
    this.formDispatch = dispatch;
  }

  componentWillMount(){
    this.setState({
      filtered_campaigns: ["", ...this.props.campaigns],
      campaigns: this.props.campaigns,
      campaign: this.props.campaign
    })
  }

  componentWillUpdate(prevProps, prevState) {
    if (this.props.campaigns.length > this.state.campaigns.length ) {
      this.setState({
        filtered_campaigns: ["", ...this.props.campaigns],
        campaigns: this.props.campaigns,
        campaign: this.props.campaign
      })
    }
  }

  handleSubmit(inValues) {
    const { voucher_id } = this.props
    this.props.updateVoucher(voucher_id, inValues)
  }

  handleUpdate(form) {
    const { campaign } = form
    this.setState({formData: form})

    this.setState({
      campaign
    })
  }

  handleChangeCampaign(value) {
    if (value === null) {
      this.setState({
        showCampaignSuggestions: false
      })
    } else {
      const newValue = ((value === "") || (value && (typeof value === "string")) ? value : (value.target.value || ""))
      this.setState({
        showCampaignSuggestions: true,
        campaign: newValue,
        filtered_campaigns: ["", ...this.props.campaigns.filter(c => c.toLowerCase().match(newValue.toLowerCase()))]
      })
      this.formDispatch(actions.change('voucher.campaign', newValue))
    }
  }

  render(){
    const { voucher_id } = this.props
    const { campaign, campaigns, filtered_campaigns } = this.state
    if (!voucher_id ) {
      return ''
    }

    let initialState = { campaign: campaign }

    const actionButtons = (
      <React.Fragment>
        <CustomOutlinedButton
          className="buttonnoto c-blue align-self-center mr-16"
          onClick={e => {
            e.preventDefault()
            this.props.handleModalClose()
          }}>CANCEL</CustomOutlinedButton>
        <CustomOutlinedButton
          className="buttonnoto c-blue align-self-center mr-16"
          onClick={e => {
            e.preventDefault()
            this.formDispatch( actions.submit('voucher') )
          }}>Save</CustomOutlinedButton>
      </React.Fragment>
    )

    return(
      <div style={{textAlign: 'center'}}>
        <InnerBar text={`Modify campaign for Voucher #${voucher_id}`}/>
        <LocalForm
          model="voucher"
          className="collection-item"
          style={{marginTop: 16}}
          initialState={initialState}
          getDispatch={(dispatch) => this.attachDispatch(dispatch)}
          onSubmit = {(values) => this.handleSubmit(values)}
        >
        <div className="d-flex">
        <Autosuggest
          suggestions={filtered_campaigns}
          alwaysRenderSuggestions={filtered_campaigns.length > 1 && this.state.showCampaignSuggestions}
          highlightFirstSuggestion
          focusInputOnSuggestionClick={false}
          getSuggestionValue={ suggestion => suggestion }
          theme={theme}
          onSuggestionSelected={ (event, {suggestion}) => {
            this.setState({showCampaignSuggestions: false})
            return suggestion
          }}
          inputProps={{
            value: this.state.campaign || '',
            onChange: (event, {newValue}) => {
              this.handleChangeCampaign(newValue)
            },
          }}
          onSuggestionsFetchRequested={ ({value}) => 'null' }
          onSuggestionsClearRequested={ () => 'null' }
          renderSuggestion={ (suggestion, { query, isHighlighted }) => suggestion }
          renderInputComponent={ props => (
            <TextInput
              id="voucher-campaign"
              placeholder="Campaign"
              nocontrol
              style={{margin: 8, marginBottom: 32}}
              value={campaign}
              helperText={"Select or type a campaign"}
              onChange={event => this.handleChangeCampaign(event)}
              onClick={event => this.handleChangeCampaign(this.state.campaign)}
              onBlur={event => {
                const handler = this
                setTimeout(function(){
                  if (handler.state.showCampaignSuggestions) {
                    handler.handleChangeCampaign(null)
                  }
                }, 200)
              }}
            />
          )}
        />
        </div>
        </LocalForm>
        {
          actionButtons
        }
      </div>
    )

  }

}

const VoucherCampaignEdit = connect()(ConnectedVoucherCampaignEdit)
export default VoucherCampaignEdit



// WEBPACK FOOTER //
// ./src/js/components/VoucherCampaignEdit.js